import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import "./Table.css";
import { useDispatch, useSelector } from "react-redux";
import { getChannel } from "../../../Store/Features/Channel/ChannelSlice";
import { getUsers } from "../../../Store/Features/Users/UserSlice";
import CircularProgress from "@mui/material/CircularProgress";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
export const Table = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ChannelData = useSelector((state) => state.channel.value);
  const Users = useSelector((state) => state.usersSlice.value);
  const Loading = useSelector((state) => state.channel.loading);
  const [query, setQuery] = useState("All");
  const [filter, setFilter] = useState([]);
  const [nonAdminUser, setNonAdminUser] = useState([]);
  const role = localStorage.getItem("role");
  useEffect(() => {
    dispatch(getChannel());
  }, []);
  useEffect(() => {
    if (role === "1") {
      dispatch(getUsers());
    }

  }, []);

  useEffect(() => {
    if (role === "1") {
      setFilter(ChannelData);
    }
  }, [ChannelData]);

  useEffect(() => {
    if (role === "1") {
      filterAdminUser();
    }
  }, [Users]);

  const filterAdminUser = () => {
    let temp = [...Users];
    temp = temp.filter((item) => {
      return !item.roles.some((item) => {
        return item.id == 1;
      });
    });
    setNonAdminUser(temp);
  };

  const eventHandler = (e) => {
    setQuery(e.target.value);
    channelFilter(e.target.value);
  };

  const channelFilter = (value) => {
    if (value == "All") {
      setFilter(ChannelData);
    } else {
      let temp = [...ChannelData];
      temp = temp.filter((item) => {
        return item.created_by?.email == value;
      });
      setFilter(temp);
    }

  };

  const columns = [
    { field: "name", headerName: "Channel Name", flex: 1 },

    {
      field: "created_at",
      headerName: "Date Created",
      flex: 1,
      render: (params) => {
        <Typography>

        </Typography>;
      }
    },
    {
      field: "productCount",
      headerName: "No. of Products",
      headerAlign: "left",
      flex: 1,

    },

    {
      field: " ",
      headerName: "",
      flex: 1,
      renderCell: (params) => (
        <Button
          sx={{ backgroundColor: "#ec492f", height: 28 }}
          onClick={() => navigate(`/Channel/${params.row.id}`)}
          className="hover"
        >
          <Typography className="button">Manage</Typography>
        </Button>
      ),
    },
  ];

  return (
    <>
      {Loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            justifyContent: "center",
            height: "40vh",
          }}
        >
          {" "}
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box sx={{ display: "flex", marginBottom: "10px" }}>
            {role == 1 ? (<Select1
              value={query}
              eventHandler={eventHandler}
              users={nonAdminUser}
            />) : null}

          </Box>
          <Box className="Table">
            <DataGrid
              rows={role == 1 ? filter : ChannelData}
              columns={columns}
              pageSizeOptions={[12]}
              autoHeight={true}
              disableRowSelectionOnClick
              slots={{
                pagination: CustomPagination,
              }}
            />
          </Box>
        </>
      )}

    </>
  );
};

function Select1({ value, eventHandler, index, users }) {
  return (
    <FormControl sx={{ width: "128px", height: "38px" }}>
      <InputLabel
        sx={{
          "font-family": "Circe",
          "font-size": "14px",
          "font-weight": 400,
          top: "3px",
        }}
      >
        Users
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label="User"
        onChange={(e) => eventHandler(e)}
        sx={{
          height: "48px",
          textTransform: "capitalize",
          "font-family": "Circe",
          "font-size": "14px",
          "font-weight": 400,
        }}
      >
        <MenuItem value={"All"} sx={{ textTransform: "capitalize" }}>
          All
        </MenuItem>
        {users?.map((item) => {
          return (
            <MenuItem value={item?.email} sx={{ textTransform: "capitalize" }}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      page={page + 1}
      count={pageCount}
      // @ts-expect-error
      sx={{
        "& .Mui-selected": {
          backgroundColor: "transparent !important",
          color: "#ec492f",
        },
      }}
      renderItem={(props2) => (
        <PaginationItem className="paginationText" {...props2} />
      )}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}
